import {ReadonlyVec3} from 'gl-matrix';

export const VEC3_ZERO: ReadonlyVec3 = [0, 0, 0];
export const VEC3_ONE: ReadonlyVec3 = [1, 1, 1];
export const VEC3_X: ReadonlyVec3 = [1, 0, 0];
